<template>
  <div :id="id" :class="inputGroupPrependClasses">
    <slot />
  </div>
</template>
<script>
export default {
  name: "BInputGroupPrepend",
  props: {
    id: {
      type: String,
      default: null,
    },
    tag: {
      type: String,
      default: "div",
    },
  },
  computed: {
    inputGroupPrependClasses() {
      return ["input-group-prepend"];
    },
  },
};
</script>
